(() => {
  const roots = [...document.querySelectorAll('[data-hb-save-root]')];
  if (!roots.length) return;

  if (!document.getElementById('HBSavedAssortmentStyles')) {
    const style = document.createElement('style');
    style.id = 'HBSavedAssortmentStyles';
    style.textContent = '.hb-save-dialog[hidden]{display:none!important}.hb-save-dialog{align-items:center;background:rgba(41,35,31,.58);display:flex;inset:0;justify-content:center;padding:20px;position:fixed;z-index:2147483000}.hb-save-dialog__panel{background:#fffdf9;border:1px solid #d8cbbd;box-shadow:0 24px 70px rgba(41,35,31,.26);color:#29231f;max-width:560px;padding:clamp(26px,5vw,44px);width:100%}.hb-save-dialog__eyebrow{color:#7b8172;font-size:10px;font-weight:800;letter-spacing:.15em;margin:0 0 12px;text-transform:uppercase}.hb-save-dialog h2{color:#49362d;font:clamp(30px,5vw,43px)/1 Georgia,serif;margin:0}.hb-save-dialog__source{color:#655d57;font-size:14px;line-height:1.55;margin:15px 0 24px}.hb-save-dialog label{display:block;font-size:12px;font-weight:800}.hb-save-dialog input{background:#fff;border:1px solid #a99b90;border-radius:0;display:block;font:16px inherit;margin-top:8px;min-height:50px;padding:12px;width:100%}.hb-save-dialog__actions{display:flex;flex-wrap:wrap;gap:8px;margin-top:20px}.hb-save-dialog button,.hb-save-dialog a{align-items:center;border:1px solid #49362d;cursor:pointer;display:inline-flex;font-size:12px;font-weight:800;justify-content:center;min-height:48px;padding:12px 20px;text-decoration:none}.hb-save-dialog__save{background:#49362d;color:#fff}.hb-save-dialog__cancel{background:#fff;color:#49362d}.hb-save-dialog__status{color:#49362d;font-size:13px;line-height:1.5;margin:16px 0 0;min-height:20px}.hb-save-dialog__success{background:#edf3eb;border:1px solid #a8b8a2;margin-top:18px;padding:16px}.hb-save-dialog__success[hidden]{display:none}.hb-save-dialog__success p{margin:0 0 12px}.hb-save-dialog__success a{background:#fff;color:#49362d}.hb-save-dialog :focus-visible{outline:3px solid #8aa38a;outline-offset:3px}@media(max-width:520px){.hb-save-dialog{align-items:flex-end;padding:0}.hb-save-dialog__panel{border-bottom:0;border-left:0;border-right:0;max-height:92vh;overflow:auto}.hb-save-dialog__actions>*{flex:1}}';
    document.head.appendChild(style);
  }

  const currency = document.documentElement.dataset.currency || 'USD';
  const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
  const rootPath = window.Shopify?.routes?.root || '/';

  roots.forEach((root) => {
    if (root.dataset.hbSaveReady === 'true') return;
    root.dataset.hbSaveReady = 'true';
    const buyerKey = root.dataset.buyerKey;
    if (!buyerKey) return;
    const storageKey = `hb-wholesale-assortments:${buyerKey}`;
    let pendingItems = [];
    let opener = null;

    const dialog = document.createElement('div');
    dialog.className = 'hb-save-dialog';
    dialog.dataset.hbSaveDialog = '';
    dialog.hidden = true;
    dialog.innerHTML = '<div class="hb-save-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="HBSavedDialogTitle"><p class="hb-save-dialog__eyebrow">Saved assortments</p><h2 id="HBSavedDialogTitle">Save for later</h2><p class="hb-save-dialog__source" data-hb-save-source></p><form data-hb-save-name-form><label for="HBSavedDialogName">Assortment name<input id="HBSavedDialogName" name="name" maxlength="60" required autocomplete="off" placeholder="Fall reorder, front table, holiday…"></label><div class="hb-save-dialog__actions"><button class="hb-save-dialog__save" type="submit">Save assortment</button><button class="hb-save-dialog__cancel" type="button" data-hb-save-cancel>Cancel</button></div><p class="hb-save-dialog__status" data-hb-save-status role="status"></p></form><div class="hb-save-dialog__success" data-hb-save-success hidden><p data-hb-save-success-copy></p><a href="/pages/wholesale?view=wholesale-saved">View saved assortments</a><button class="hb-save-dialog__cancel" type="button" data-hb-save-done>Keep shopping</button></div></div>';
    document.body.appendChild(dialog);

    const form = dialog.querySelector('[data-hb-save-name-form]');
    const nameInput = form.querySelector('input[name="name"]');
    const source = dialog.querySelector('[data-hb-save-source]');
    const status = dialog.querySelector('[data-hb-save-status]');
    const success = dialog.querySelector('[data-hb-save-success]');
    const successCopy = dialog.querySelector('[data-hb-save-success-copy]');

    const read = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (_) { return []; }
    };
    const write = (assortments) => {
      try { localStorage.setItem(storageKey, JSON.stringify(assortments)); return true; }
      catch (_) { status.textContent = 'This browser could not save the assortment. Check private-browsing or storage settings and try again.'; return false; }
    };
    const units = (items) => items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const total = (items) => items.reduce((sum, item) => sum + Number(item.price || 0), 0);
    const close = () => {
      dialog.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      form.hidden = false;
      success.hidden = true;
      status.textContent = '';
      pendingItems = [];
      opener?.focus();
    };
    const open = (items, button, label) => {
      if (!items.length) return;
      pendingItems = items;
      opener = button;
      source.textContent = `${label} · ${units(items)} unit${units(items) === 1 ? '' : 's'} · ${money(total(items))}. Saving does not reserve inventory.`;
      nameInput.value = '';
      form.hidden = false;
      success.hidden = true;
      status.textContent = '';
      dialog.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => nameInput.focus());
    };
    const selectionItems = () => [...root.querySelectorAll('[data-hb-qty], [data-hb-pdp-qty]')].map((input) => {
      const quantity = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
      return {
        variantId: Number(input.dataset.variantId),
        quantity,
        title: input.dataset.productTitle || 'Wholesale product',
        variantTitle: input.dataset.variantTitle || '',
        image: input.dataset.image || null,
        price: quantity * Number(input.dataset.price || 0),
      };
    }).filter((item) => item.variantId && item.quantity > 0);
    const cartItems = async () => {
      const response = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Your cart could not be loaded. Please try again.');
      const cart = await response.json();
      return (cart.items || []).map((item) => ({
        variantId: Number(item.variant_id || item.id),
        quantity: Number(item.quantity || 0),
        title: item.product_title || item.title || 'Wholesale product',
        variantTitle: item.variant_title || '',
        image: item.image || null,
        price: Number(item.final_line_price || item.line_price || 0),
      })).filter((item) => item.variantId && item.quantity > 0);
    };

    root.querySelectorAll('[data-hb-save-selections]').forEach((button) => button.addEventListener('click', () => {
      const items = selectionItems();
      if (!items.length) return;
      open(items, button, 'Current selections');
    }));
    root.querySelectorAll('[data-hb-save-cart]').forEach((button) => button.addEventListener('click', async () => {
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading cart…';
      try {
        const items = await cartItems();
        if (!items.length) throw new Error('Your cart is empty. Add products before saving an assortment.');
        open(items, button, 'Current wholesale cart');
      } catch (error) {
        window.alert(error.message || 'Your cart could not be saved. Please try again.');
      } finally {
        button.textContent = original;
        button.disabled = false;
      }
    }));

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const name = nameInput.value.trim().slice(0, 60);
      if (!name || !pendingItems.length) return;
      const saved = read();
      saved.unshift({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, name, savedAt: new Date().toISOString(), items: pendingItems });
      if (!write(saved.slice(0, 30))) return;
      form.hidden = true;
      success.hidden = false;
      successCopy.textContent = `${name} was saved on this device.`;
      try { window.dispatchEvent(new CustomEvent('hb:saved-assortment-created', { detail: { source: opener?.dataset.hbContext || 'portal', units: units(pendingItems) } })); } catch (_) {}
    });
    dialog.querySelectorAll('[data-hb-save-cancel], [data-hb-save-done]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    document.addEventListener('keydown', (event) => { if (!dialog.hidden && event.key === 'Escape') close(); });
  });
})();
